import { Controller } from "@hotwired/stimulus"

// Phase 2.9 — Approver-pool form. Swaps the per-kind input panel based
// on the selected Kind so admins never see raw config_json. Each panel
// is marked `data-pool-form-target="panel"` with `data-kind="..."`.
export default class extends Controller {
  static targets = ["kind", "panel", "kindHint", "roleName", "roleNameHint"]
  static values = { kind: String }

  connect() {
    this._sync(this.kindValue || (this.hasKindTarget ? this.kindTarget.value : "company_role"))
    this._refreshRoleNameHint()
  }

  kindChanged() {
    this._sync(this.kindTarget.value)
  }

  roleNameChanged() {
    this._refreshRoleNameHint()
  }

  _sync(kind) {
    this.panelTargets.forEach(p => {
      p.classList.toggle("hidden", p.dataset.kind !== kind)
    })
    if (this.hasKindHintTarget) {
      this.kindHintTarget.textContent = HINTS[kind] || ""
    }
  }

  _refreshRoleNameHint() {
    if (!this.hasRoleNameTarget || !this.hasRoleNameHintTarget) return
    const panel = this.roleNameTarget.closest('[data-kind="company_role"]')
    let known = []
    try { known = JSON.parse(panel?.dataset.knownTitles || "[]") } catch (_) { known = [] }
    const typed = this.roleNameTarget.value.trim().toLowerCase()
    const matches = typed.length > 0 && known.some(t => t.toLowerCase() === typed)
    const noMatch = typed.length > 0 && !matches
    this.roleNameHintTarget.classList.toggle("hidden", !noMatch)
  }
}

const HINTS = {
  company_role: "Members of a CompanyRole on the project being approved (e.g. Director, Bond Trustee).",
  user_in_role_within_company: "Top-level company role holders (Commander = exec, Captain = PM). Company-wide.",
  named_user: "An explicit user list. Use sparingly — prefer role-based pools so memberships stay live.",
  project_field: "The user stored in a specific column on the Project record (e.g. winning contractor).",
  scoring_rubric: "The chair of a Capital Scoring Rubric — used by Capital Request approvals."
}
